import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CheckoutStateService, PaymentMethod } from '@b2b/features/cart/core/checkout-state.service';

@Component({
  selector: 'checkout-payment-method',
  imports: [CommonModule, TranslateModule],
  templateUrl: './checkout-payment-method.component.html',
  styleUrl: './checkout-payment-method.component.scss',
})
export class CheckoutPaymentMethodComponent {
  selectedMethod: PaymentMethod = 'PIX';

  constructor(private checkoutState: CheckoutStateService) {
    const currentMethod = this.checkoutState.paymentMethod();
    if (currentMethod === null) {
      // Nenhum método foi selecionado ainda: define PIX como padrão e persiste no state
      this.selectedMethod = 'PIX';
      this.checkoutState.setPaymentMethod('PIX');
    } else {
      this.selectedMethod = currentMethod;
    }
  }

  onMethodChange(method: PaymentMethod): void {
    this.selectedMethod = method;
    this.checkoutState.setPaymentMethod(method);
  }
}
